import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class SetArbetsorderInmatningshandelssortimentJusteringCommand  extends BasicCommand<SetArbetsorderInmatningshandelssortimentJusteringCommand > {
    get primaryKey(): IPrimaryKey<SetArbetsorderInmatningshandelssortimentJusteringCommand > {
        return {
            InmatningshandelssortimentId: this.InmatningshandelssortimentId
        };
    }
    InmatningshandelssortimentId: number;
    mattslagJusterad: string;
    stockmatningKravsJusterad: boolean;
    kvalitetsklassningJusterad: boolean;
    prioriteradMatmetodJusterad: string;
    andraMattslagJusterad: boolean;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetArbetsorderInmatningshandelssortimentJusteringCommand";
    constructor(init: (instance: SetArbetsorderInmatningshandelssortimentJusteringCommand) => void) {
        super(SetArbetsorderInmatningshandelssortimentJusteringCommand.$type, SetArbetsorderInmatningshandelssortimentJusteringCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
